export const categories = [
  {
    id: 1,
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    description: 'Discover the latest sneaker and footwear collections',
    icon: 'ri-footprint-line',
    trending: true,
    itemCount: '2,450+ items',
  },
  {
    id: 2,
    name: 'Hoodies / Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    description: 'Cozy hoodies and stylish sweaters for every season',
    icon: 'ri-t-shirt-line',
    trending: true,
    itemCount: '1,830+ items',
  },
  {
    id: 3,
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    description: 'Essential tees and graphic tops for casual wear',
    icon: 'ri-shirt-line',
    trending: false,
    itemCount: '3,120+ items',
  },
  {
    id: 4,
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    description: 'Outerwear and jackets for all weather conditions',
    icon: 'ri-user-3-line',
    trending: true,
    itemCount: '980+ items',
  },
  {
    id: 5,
    name: 'Pants / Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    description: 'Trendy bottoms from denim to casual shorts',
    icon: 'ri-checkbox-blank-line',
    trending: false,
    itemCount: '1,560+ items',
  },
  {
    id: 6,
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    description: 'Caps, beanies, and hats to complete your look',
    icon: 'ri-user-smile-line',
    trending: false,
    itemCount: '640+ items',
  },
  {
    id: 7,
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    description: 'Coordinated outfit sets for effortless styling',
    icon: 'ri-stack-line',
    trending: false,
    itemCount: '420+ items',
  },
  {
    id: 8,
    name: 'Underwear / Underpants',
    slug: 'underwear-underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    description: 'Comfortable essentials for everyday wear',
    icon: 'ri-check-line',
    trending: false,
    itemCount: '890+ items',
  },
  {
    id: 9,
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    description: 'Sports jerseys and athletic performance wear',
    icon: 'ri-basketball-line',
    trending: false,
    itemCount: '730+ items',
  },
  {
    id: 10,
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    description: 'Watches, jewelry, and finishing touches',
    icon: 'ri-vip-diamond-line',
    trending: true,
    itemCount: '1,150+ items',
  },
  {
    id: 11,
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    description: 'Backpacks, crossbody bags, and travel essentials',
    icon: 'ri-briefcase-line',
    trending: false,
    itemCount: '870+ items',
  },
  {
    id: 12,
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    description: 'Leather belts and waist accessories for any outfit',
    icon: 'ri-links-line',
    trending: false,
    itemCount: '350+ items',
  },
  {
    id: 13,
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    description: 'Signature fragrances and premium scents',
    icon: 'ri-drop-line',
    trending: false,
    itemCount: '520+ items',
  },
  {
    id: 14,
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    description: 'Discover unique finds and miscellaneous items',
    icon: 'ri-more-line',
    trending: false,
    itemCount: '1,200+ items',
  },
];

export const trendingCategories = [
  {
    id: 1,
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Single%20premium%20off%20white%20cream%20leather%20sneaker%20with%20subtle%20grey%20suede%20panel%20details%20resting%20on%20a%20textured%20natural%20linen%20fabric%20surface%2C%20soft%20diffused%20window%20light%20from%20the%20right%20creating%20gentle%20gradient%20shadows%2C%20minimal%20product%20photography%20style%20with%20negative%20space%20on%20the%20left%2C%20clean%20contemporary%20aesthetic%2C%20warm%20neutral%20tones%20of%20cream%20beige%20and%20light%20grey%2C%20professional%20editorial%20catalog%20shot%2C%20sharp%20focus%20on%20the%20shoe%20texture%20and%20silhouette&width=600&height=450&seq=trend-shoes-v2-20260712&orientation=landscape',
    update: '2026 Update',
    itemCount: '2,450+ items',
  },
  {
    id: 2,
    name: 'Hoodies / Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20neatly%20folded%20sage%20green%20organic%20cotton%20hoodie%20with%20drawstring%20detail%20visible%20placed%20on%20a%20light%20wooden%20surface%20beside%20a%20small%20ceramic%20mug%2C%20soft%20morning%20sunlight%20filtering%20through%20nearby%20window%20creating%20warm%20highlights%20on%20the%20fabric%20texture%2C%20cozy%20lifestyle%20scene%20with%20calming%20earthy%20tones%20of%20olive%20sage%20and%20natural%20wood%2C%20minimalist%20aesthetic%2C%20editorial%20homewear%20photography%2C%20peaceful%20atmosphere%2C%20high%20detail%20showing%20fabric%20weave%20and%20ribbed%20cuff%20texture&width=600&height=450&seq=trend-hoodies-v2-20260712&orientation=landscape',
    update: '2026 Update',
    itemCount: '1,830+ items',
  },
  {
    id: 3,
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20arrangement%20of%20premium%20minimalist%20accessories%20including%20a%20brushed%20stainless%20steel%20mesh%20watch%20with%20navy%20blue%20dial%20on%20a%20smooth%20white%20marble%20surface%2C%20accompanied%20by%20a%20delicate%20gold%20chain%20bracelet%20with%20subtle%20geometric%20charm%2C%20and%20a%20pair%20of%20matte%20black%20wayfarer%20sunglasses%20folded%20neatly%2C%20soft%20overhead%20lighting%20creating%20minimal%20shadows%2C%20luxury%20boutique%20window%20display%20aesthetic%2C%20clean%20sophisticated%20palette%20of%20navy%20gold%20silver%20black%20and%20white%2C%20editorial%20product%20styling%2C%20high%20contrast%20sharp%20detail&width=600&height=450&seq=trend-accessories-v2-20260712&orientation=landscape',
    update: '2026 Update',
    itemCount: '1,150+ items',
  },
];